const imageCache = new Map();
const MAX_IMAGE_CACHE_SIZE = 700;

function normalizePhotoUrl(person = {}) {
  const label = String(person.name || person.id || 'person')
    .replace(/[&<>"']/g, (character) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&apos;',
    }[character]))
    .slice(0, 18);
  const fallback = `data:image/svg+xml,${encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160 160">
      <defs>
        <linearGradient id="bg" x1="0" x2="1" y1="0" y2="1">
          <stop offset="0" stop-color="#f8d7ff"/>
          <stop offset="1" stop-color="#b8f7ff"/>
        </linearGradient>
      </defs>
      <rect width="160" height="160" fill="url(#bg)"/>
      <circle cx="80" cy="62" r="28" fill="#2b2b2b" opacity="0.76"/>
      <path d="M34 138c8-32 32-48 46-48s38 16 46 48" fill="#2b2b2b" opacity="0.76"/>
      <text x="80" y="150" text-anchor="middle" font-family="Arial, sans-serif" font-size="12" fill="#2b2b2b">${label.slice(0, 18)}</text>
    </svg>
  `)}`;
  const url = person.imageURL || person.image || fallback;
  return url.includes('licdn') ? fallback : url;
}

function touchCacheEntry(key, entry) {
  imageCache.delete(key);
  imageCache.set(key, entry);
  while (imageCache.size > MAX_IMAGE_CACHE_SIZE) {
    const oldestKey = imageCache.keys().next().value;
    imageCache.delete(oldestKey);
  }
}

export function getPersonPhotoImage(person, { onLoad } = {}) {
  if (!person) return null;

  const url = normalizePhotoUrl(person);
  const cached = imageCache.get(url);
  if (cached) {
    touchCacheEntry(url, cached);
    return cached.image;
  }

  const image = new Image();
  const entry = { image };
  touchCacheEntry(url, entry);

  image.onload = () => {
    image.dataset.loaded = 'true';
    onLoad?.();
  };
  image.onerror = () => {
    image.dataset.failed = 'true';
    onLoad?.();
  };
  image.crossOrigin = 'anonymous';
  image.decoding = 'async';
  image.loading = 'eager';
  image.src = url;

  return image;
}

export function preloadPersonPhotoImages(people = [], onLoad) {
  people.forEach((person) => {
    getPersonPhotoImage(person, { globalScale: 1, onLoad });
  });
}

export function prunePersonPhotoCache(people = []) {
  const activeUrls = new Set(people.map(normalizePhotoUrl));
  for (const key of imageCache.keys()) {
    if (!activeUrls.has(key) && imageCache.size > MAX_IMAGE_CACHE_SIZE / 2) {
      imageCache.delete(key);
    }
  }
}
